import { getVersionForClone } from '@/utils'

import { BaseButton, baseButtonCls } from './BaseButton'
import { Clone1Button, clone1ButtonCls } from './Clone1Button'

export * from './BaseButton'

export const buttonCls = getVersionForClone({
	base: baseButtonCls,
	clone1: clone1ButtonCls,
})

export const Button = getVersionForClone({
	base: BaseButton,
	clone1: Clone1Button,
})
